// extracted by mini-css-extract-plugin
export default {"container":"FreemiumInterview_container__H-h3A","header1":"FreemiumInterview_header1__asQm3"};